// extracted by mini-css-extract-plugin
export default {"root":"LevelMenu_root__WdCLk","heading":"LevelMenu_heading__IDDZF","link":"LevelMenu_link__XIuCR","icon":"LevelMenu_icon__aAon4","filter":"LevelMenu_filter__0RxQy"};